module.exports = __webpack_public_path__ + "static/media/educationArticle3.81a172f3.jpg";